module.exports = __webpack_public_path__ + "static/media/018.5a83408f.jpg";